import "./movieLoading.css";

export default function MovieLoading() {
  return (
    <div className="main movie-detail-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-3">
            <div className="movieLoading-poster">
              <div className="movieLoading-poster-header" />
            </div>
          </div>
          <div className="col-9">
            <div className="container movieLoading-detail">
              <div className="row">
                <div className="col-md-12">
                  <div className="movieLoading-title loading" />
                  <div className="movieLoading-text lg loading" />
                  <div className="movieLoading-text md loading" />
                  <div className="movieLoading-text lg loading" />
                  <div className="movieLoading-text sm loading" />
                  <div className="movieLoading-text md loading" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
